import { gql } from '@utils/gpl-dedup';
import { listTypeFragment } from '@graphql/listTypes/fragments';

export const listItemFragment = gql`
  fragment listItem on ListItem {
    name
    list_type_id
    description
    meta
    created_at
    updated_at
    list_type {
      ...listType
    }
  }
  ${listTypeFragment}
`;
